import React, {useState} from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import HeadingArea from '../../general/HeadingArea';
import ResponseMsg2 from '../../general/ResponseMsg2';

const OnlineExamReport = ({setLoading}) => {
         const { state } = useLocation();
  const { exam, examReport } = state;
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
const navigate = useNavigate();
console.log(state.exam, state.examReport);


    const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


const questionList = exam.ques || [];

const totalQuestions = questionList.length;
const totalMarks = questionList.reduce((sum, q) => sum + Number(q.marks || 0), 0);


  return (
    <>
              <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Online Exam' message2='Student Report' />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


       <div className='profile-card'>


<div className='d-flex justify-content-between'>
              <p className='profile-heading my-0'>{state.exam.title} Report- {
  (() => {
    try {
      const parsed = JSON.parse(state.exam.class_id);
      return parsed.className || '';
    } catch {
      return '';
    }
  })()
} {state.exam.sub_name} ({state.exam.sub_type})({state.exam.sub_code})</p>
                                                    <button onClick={() => navigate('/admin/create-exam')} type='button' className='profile-btn2'>
                    Go Back
                  </button>
</div>
{/* flex ends */}


<div className='table-responsive mt-4'>
  <table className='w-100 text-center'>
    <thead className='account-thead'>
      <tr>
        <th className='border'>Student</th>
        <th className='border'>Admission No</th>
        <th className='border'>Total Ques</th>
        <th className='border'>Attempted</th>
        <th className='border'>Total Marks</th>
        <th className='border'>Obtained</th>
        <th className='border'>Submit On</th>
        <th className='border'>Status</th>
      </tr>
    </thead>


    <tbody>
      {examReport.length > 0 ? (
        examReport.map((report, index) => {
const attempted = report.answer
  ? JSON.parse(report.answer).filter((ans) => ans.a !== null && ans.a !== '').length
  : 0;

return            (
          <tr key={index} className='account-tr'>
            <td className='border'>{report.student_name}</td>
            <td className='border'>{report.admission_no}</td>
            <td className='border'>{totalQuestions}</td>
            <td className='border'>{attempted}</td>
            <td className='border'>{totalMarks}</td>
            <td className='border'>{report.mark_obtained}</td>
            <td className='border'>{formatDateTime(report.submit_on)}</td>
            <td className={`border fw-semibold ${report.status == 'Passed' ? 'text-success' : 'text-danger'}`}>{report.status}</td>
          </tr>
        )})
      ) : (

                              <tr className='account-tr'>
          <td colSpan={7} className="py-3">
            No Submission Available.
          </td>
        </tr>
      )}
    </tbody>


</table>
</div>





</div>

       </div>
       </section>
    
    </>
  )
}

export default OnlineExamReport